import z from 'zod';

import { socialApiClient } from '@/shared/api-client/social-api-client';

import { type DiscoveryMessage } from '../discovery-schema';

export const selectCommonalityRequestSchema = z.object({
  message_id: z.string(),
  selected_post_feature_conditions: z.array(z.string()).min(1).max(5),
});

export type SelectCommonalityRequest = z.infer<typeof selectCommonalityRequestSchema>;
export type SelectCommonalityResponse = DiscoveryMessage;

export async function selectCommonality(
  discoverySessionId: string,
  request: SelectCommonalityRequest,
  signal?: AbortSignal,
): Promise<SelectCommonalityResponse> {
  const parsedRequest = selectCommonalityRequestSchema.parse(request);
  const response = await socialApiClient.post(
    `discovery-sessions/${discoverySessionId}/select-commonality`,
    {
      json: parsedRequest,
      signal,
    },
  );

  return await response.json();
}
